import { BadgeStateItem } from "~/shared/components/StatesDescription"
import { BadDebtCategory } from "@oysterhr/schema"

export const PaymentStatusLabelsMap: Record<BadDebtCategory, BadgeStateItem> = {
  [BadDebtCategory.InDebt]: {
    translationKey: "states.inDebt.label",
    descriptionKey: "states.inDebt.description",
    variation: "error",
  },
  [BadDebtCategory.MajorDelays]: {
    translationKey: "states.majorDelays.label",
    descriptionKey: "states.majorDelays.description",
    variation: "gray",
  },
  [BadDebtCategory.MinorDelays]: {
    translationKey: "states.minorDelays.label",
    descriptionKey: "states.minorDelays.description",
    variation: "gray",
  },
  [BadDebtCategory.UpToDate]: {
    translationKey: "states.upToDate.label",
    descriptionKey: "states.upToDate.description",
    variation: "gray",
  },
}

export const RestrictionStateLabelsMap: Record<
  "restricted" | "non-restricted",
  Omit<BadgeStateItem, "descriptionKey">
> = {
  restricted: {
    translationKey: "states.restricted.label",
    variation: "error",
  },
  "non-restricted": {
    translationKey: "states.non-restricted.label",
    variation: "success",
  },
}
